import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const AssessmentRegimesService = {
  assessmentRegimes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  pollutants: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/p",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  assessmenttypes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/at",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  objecttypes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/ot",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  reportingmetrics: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/rm",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  protectiontargets: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/pt",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  assessmentthresholdexceedances: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/ate",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  zones: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/z",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  assessmenttypes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_regimes/at",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  assessmentdataAll: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/assessment_data",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }, 
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/assessment_regimes/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (assessment_regimes) {
    const requestData = {
      method: "post",
      url: "/api/management/assessment_regimes/update",
      data: assessment_regimes
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  updateData: async function (assessment_regimes) {
    //// debugger;
    const requestData = {
      method: "post",
      url: "/api/management/assessment_data/update",
      data: assessment_regimes
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  deleteData: async function (assessment_regimes) {
    //// debugger;
    const requestData = {
      method: "post",
      url: "/api/management/assessment_data/delete",
      data: assessment_regimes
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },    
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/assessment_regimes",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  importData: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/assessment_data",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default AssessmentRegimesService;
